import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { MenuItem, Select } from '@material-ui/core'
import { APP_LANGUAGES } from 'constants/index'
import { changeLang } from 'reducers/locale/reducer'
import messages from './translate'
import './style.scss'

class Locale extends Component {
  constructor(props) {
    super(props)
    const { lang, defaultLang } = this.props
    const language =
      lang && APP_LANGUAGES.hasOwnProperty(lang) ? lang : defaultLang

    this.state = {
      lang: APP_LANGUAGES[language],
    }
  }

  componentDidUpdate(prevProps) {
    const { lang } = this.props

    if (lang !== prevProps.lang) {
      this.setState({
        lang: APP_LANGUAGES[lang],
      })
    }
  }

  onChange = lang => {
    this.props.changeLang(lang)
  }

  render() {
    const {
      intl: { formatMessage },
    } = this.props
    const { lang } = this.state
    const langs = Object.keys(APP_LANGUAGES)

    return (
      <div className="lang-list">
        <Select
          value={lang.key}
          onChange={({ target: { value } }) => this.onChange(value)}
          MenuProps={{ getContentAnchorEl: null }}>
          {langs.map(key => {
            const lang = APP_LANGUAGES[key]
            const langTitle = lang.title

            return (
              <MenuItem key={key} value={key}>
                {formatMessage(messages[langTitle])}
              </MenuItem>
            )
          })}
        </Select>
      </div>
    )
  }
}

const _Locale = connect(
  state => ({
    lang: state.getIn(['locale', 'lang']),
    defaultLang: state.getIn(['locale', 'defaultLang']),
  }),
  {
    changeLang,
  },
)(Locale)

export default injectIntl(_Locale)
